type URLs = {
  dashboardDataPath: string;
  additionalCostsPath: string;
  dashboardConfigurationPath: string;
  notesPath: string;
};

export const getUrls = (customerDomain: string): URLs => {
  return {
    dashboardDataPath: `/api/${customerDomain}/performance/dashboard-data`,
    additionalCostsPath: `/api/${customerDomain}/insights/api/additional-costs-data/`,
    dashboardConfigurationPath: `/api/${customerDomain}/insights/api/dashboard-configuration/`,
    notesPath: `/api/${customerDomain}/insights/api/notes/`,
  };
};
